
export type UpdateUserProfile404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
